const Constants = {
  stage: "stage",
  preproduction: "preproduction",
  production: "production",
};

export default Constants;
